import * as React from 'react';
import { Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import numpypandaslogo from './imgs/FrameworkCards/numpy-pandas-logo.svg';
import matplotliblogo from './imgs/FrameworkCards/matplotlib-logo.svg';
import reactflasklogo from './imgs/FrameworkCards/reactflasklogo.svg';
import tensorflowscikitlogo from './imgs/FrameworkCards/tensorflowscikit-logo.svg';

function Cards(cardtitle) {
  switch (cardtitle) {
    case "Data Science":
      return (
        <Card bg="dark" className="framework-card" key={cardtitle}>
          <div className="framework-card-logo-container">
            <img src={numpypandaslogo} alt="NumPy & Pandas Logo" className="framework-card-logo" />  
          </div>
          <Card.Body className="d-flex flex-column justify-content-between p-4">
            <div>
              <Card.Title className="fw-bold mb-3">{cardtitle}</Card.Title>
              <Card.Text style={{ fontSize: "14.5px", lineHeight: "1.6", color: "rgba(255,255,255,0.85)" }}>
                Over a span of 2 years and the <a href="https://www.summersteminstitute.org/" target="_blank" rel="noreferrer" style={{ color: 'var(--color-accent)', fontWeight: 'bold' }}>SSI data science/statistics and research bootcamp</a>, I have practiced many methods and techniques in processing, calculating, and interpreting data. This includes processing text using NLP methods (document similarity with cosine similarity/TF-IDF and sentiment analysis), image classification using Convolutional Neural Networks, and TimeSeries stock forecasting with LSTMs.
              </Card.Text>
            </div>
          </Card.Body>
          <Card.Footer className="bg-transparent border-0 pt-0 pb-4 px-4">
            <p className="m-0" style={{ fontSize: "14px" }}>
              Check it out &rarr; <a href="https://numpy.org/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>NumPy</a>, <a href="https://pandas.pydata.org/docs/user_guide/index.html" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>Pandas</a>
            </p>
          </Card.Footer>
        </Card>
      );
    case "Web Development":
      return (
        <Card bg="dark" className="framework-card" key={cardtitle}>
          <div className="framework-card-logo-container">
            <img src={reactflasklogo} alt="React & Flask Logo" className="framework-card-logo" />  
          </div>
          <Card.Body className="d-flex flex-column justify-content-between p-4">
            <div>
              <Card.Title className="fw-bold mb-3">{cardtitle}</Card.Title>
              <Card.Text style={{ fontSize: "14.5px", lineHeight: "1.6", color: "rgba(255,255,255,0.85)" }}>
                Web development was an important step for me to fully bring my software solutions to life. I realized that the complex backends and models I create would ultimately be inaccessible without an intuitive, beautiful interface that allows users to interact with them seamlessly. A prediction model is only valuable when packaged inside a highly responsive and clean user interface.
              </Card.Text>
            </div>
          </Card.Body>
          <Card.Footer className="bg-transparent border-0 pt-0 pb-4 px-4">
            <p className="m-0" style={{ fontSize: "14px" }}>
              Check it out &rarr; <a href="https://reactjs.org/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>React</a>, <a href="https://flask.palletsprojects.com/en/2.1.x/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>Flask</a>
            </p>
          </Card.Footer>
        </Card>
      );
    case "Machine Learning":
      return (
        <Card bg="dark" className="framework-card" key={cardtitle}>
          <div className="framework-card-logo-container">
            <img src={tensorflowscikitlogo} alt="Tensorflow & Scikit-Learn Logo" className="framework-card-logo" /> 
          </div>
          <Card.Body className="d-flex flex-column justify-content-between p-4">
            <div>
              <Card.Title className="fw-bold mb-3">{cardtitle}</Card.Title>
              <Card.Text style={{ fontSize: "14.5px", lineHeight: "1.6", color: "rgba(255,255,255,0.85)" }}>
                There are many machine learning algorithms and method variations I have explored, ranging from linear regression to deep neural networks. I have learned how to process and leverage multi-dimensional datasets (tabular, image, text, and temporal data), implementing them using Tensorflow's Sequential, Functional, and custom Subclassed Model APIs.
              </Card.Text>
            </div>
          </Card.Body>
          <Card.Footer className="bg-transparent border-0 pt-0 pb-4 px-4">
            <p className="m-0" style={{ fontSize: "14px" }}>
              Check it out &rarr; <a href="https://tensorflow.org/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>Tensorflow</a>, <a href="https://scikit-learn.org/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>Scikit-Learn</a>
            </p>
          </Card.Footer>
        </Card>
      );
    case "Data Visualization":
      return (
        <Card bg="dark" className="framework-card" key={cardtitle}>
          <div className="framework-card-logo-container">
            <img src={matplotliblogo} alt="Matplotlib Logo" className="framework-card-logo" />  
          </div>
          <Card.Body className="d-flex flex-column justify-content-between p-4">
            <div>
              <Card.Title className="fw-bold mb-3">{cardtitle}</Card.Title>
              <Card.Text style={{ fontSize: "14.5px", lineHeight: "1.6", color: "rgba(255,255,255,0.85)" }}>
                During my time in the Summer STEM Institute course, our statistics lecturer would close each class with a powerful core moral. One that stuck with me is that data always tells a story, and a picture is worth a thousand words. Visualizations allow us to distill complex numerical structures and convey clear, elegant insights that are instantly understandable to stakeholders.
              </Card.Text>
            </div>
          </Card.Body>
          <Card.Footer className="bg-transparent border-0 pt-0 pb-4 px-4">
            <p className="m-0" style={{ fontSize: "14px" }}>
              Check it out &rarr; <a href="https://matplotlib.org/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>Matplotlib</a> 
            </p>
          </Card.Footer>
        </Card>
      );
    default:
      return <p key="notfound">Card does not exist</p>;
  }
}

export default Cards;